export const currencyFormatter = Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
